// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2_lVo","head":"ProcedureTableInfo_head__24iSj"};